import React from 'react'
import { RefSelectProps, SelectProps } from 'antd'
import { DefaultOptionType } from 'antd/es/select'
import { useSelector } from 'react-redux'
import { ReportDataType } from '../../../../redux/context/reports/types'
import { BudgetingScenario } from '../../types/BudgetingScenario'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import ScenarioSelect from './ScenarioSelect'

interface ScenarioSelectProps extends SelectProps {
  dataType?: ReportDataType.budget | ReportDataType.forecast
  optionSelector?: (data: BudgetingScenario[]) => DefaultOptionType[]
}

const CtxScenarioSelect = React.forwardRef<RefSelectProps, ScenarioSelectProps>((props, ref) => {
  const companyId = useSelector(contextCompanyIdSelector)!

  return <ScenarioSelect ref={ref} companyId={companyId} {...props} />
})

CtxScenarioSelect.displayName = 'CtxScenarioSelect'

export default CtxScenarioSelect
